import {
  ValueWrapper,
  ValueWrapperArray,
} from 'src/components/data-entry-ui/ValueWrapper';

export const createArrayField = <T extends Record<string, unknown>>(
  fieldName: string,
  inputFields: ValueWrapper<keyof T>[],
  title: string,
  initialElements?: ValueWrapper<T>[],
): { [fieldName: string]: ValueWrapperArray<T> } => {
  const element: ValueWrapper<T> = inputFields.reduce((acc, curr) => {
    return Object.assign(acc, curr);
  }, {} as ValueWrapper<T>);

  return {
    [fieldName]: {
      element,
      initialElements,
      title,
    },
  };
};
